import { User } from './user';

export class Data {

    id: number;
    date_create: string ;
    date_modif: string;
    create_by: User;
    // Activated: boolean;

    constructor() {
      this.id = 0;
    }

    formatDate(date: string) {

      // le format anglais facilite le tri car l'ordre est gerer

      // format français
      if (date !== null && date !== undefined) {
        const tabDate = date.split(' ');
        const tab = tabDate[0].split('-');
        if (tabDate[1] !== undefined)
        return  tab[2] + '/' + tab[1] + '/' + tab[0] + ' ' + tabDate[1];
        else
        return  tab[2] + '/' + tab[1] + '/' + tab[0];
        // return new Date(date).toISOString;
      } else {
        return null;
      }

    }

    englishFormatDate(date: string) {


      // format anglais
      if (date !== null && date !== undefined) {
        const tabDate = date.split(' ');
        const tab = tabDate[0].split('-');
        if (tabDate[1] !== undefined)
        return  tab[0] + '/' + tab[1] + '/' + tab[2] + ' ' + tabDate[1];
        else
        return  tab[0] + '/' + tab[1] + '/' + tab[2];
        // return new Date(date).toISOString;
      } else {
        return null;
      }

    }

}
